import * as React from 'react';

import { useLockFn } from 'ahooks';
import { Flex, Form, notification } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PrimitiveForm } from 'components';
import { useUserValue } from 'context';
import { createUser, updateUser } from 'services';
import { PATHNAME, replaceExtraSeparator } from 'utils';

import { UserFormAction } from './action';
import { UserFormContent } from './content';

const {
  LOCAL: {
    USERS: { BASE_URL: USERS_BASE_URL },
  },
} = PATHNAME;

type FieldType = Pick<
  ReturnType<typeof useUserValue>,
  'lastName' | 'userName' | 'phoneNumber' | 'telNumber' | 'email' | 'roleName'
>;

const UserForm = () => {
  const [form] = Form.useForm<FieldType>();
  const {
    id = '',
    firstName = '',
    displayName,
    avatarId,
    defaultName,
    defaultRoleName,
    mode,
  } = useUserValue();
  const navigate = useNavigate();

  const formatedDisplayName = replaceExtraSeparator(
    displayName ?? firstName ?? '',
    'clean',
    ' ',
  );

  const onFinish = useLockFn(
    async ({
      lastName,
      userName,
      phoneNumber = '',
      telNumber,
      email,
      roleName = defaultRoleName!,
    }: FieldType) => {
      const isUpdatedMode = mode === 'Update';

      const params: Parameters<typeof updateUser>[0] = {
        id,
      };
      const body: Parameters<typeof updateUser>[1] = {
        firstName,
        lastName,
        displayName: formatedDisplayName,
        userName,
        phoneNumber,
        telNumber,
        email,
        avatarId,
        roleName,
      };

      (isUpdatedMode ? updateUser(params, body) : createUser(body))
        .then(() => {
          notification.success({
            message: `کاربر ${isUpdatedMode ? defaultName : firstName} با موفقیت ${isUpdatedMode ? 'ویرایش' : 'ساخته'} شد.`,
          });
          navigate(USERS_BASE_URL);
        })
        .catch(message => {
          notification.error({ message });
        });
    },
  );

  return (
    <PrimitiveForm
      form={form}
      fields={[
        {
          name: 'firstName',
          value: firstName,
        },
        {
          name: 'displayName',
          value: formatedDisplayName,
        },
      ]}
      onFinish={onFinish}
    >
      <Flex
        className='*:rounded *:bg-white max-xl:flex-col max-xl:last:*:sticky max-xl:last:*:inset-x-0 max-xl:last:*:bottom-0 max-xl:last:*:z-10 max-xl:last:*:shadow-inner xl:items-start xl:first:*:basis-[70%] xl:last:*:basis-[30%]'
        gap='large'
      >
        <UserFormContent />
        <UserFormAction />
      </Flex>
    </PrimitiveForm>
  );
};

export { UserForm };
